import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { BASE_URL, BASE_URL_PREBID } from "../../config/axios";
import { ToastContainer, toast } from "react-toastify";

import usePermission from "../../config/permissions";
// import { handleErrorToast } from "../CustomFunctions";
import {
    AddwithWhiteCircle,
    CheckGreen,
    CrossRed,
    DeleteDustbin,
    DropdownArrow,
    PDFIcon,
    UpdatePencil,
    Active,
    SearchBig,
    Filter,
    CircularGrid
} from "../AllSvg";
import { formatDate } from "../Date";
import Loader from '../Loader';

import { formattedDateLong } from "../Date";
import Dashboardnavbarcopy from "../../layout/Dashboardnavbar";
import { formatCurrencyIndian, handleErrorToast, formatRoundoff2D } from "../custom";


const Progressprebid = () => {


    const today = new Date();
    today.setDate(today.getDate() - 1);
    const year = today.getFullYear();
    const month = today.getMonth() + 1;

    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 10; // starting 20 years ago
    const endYear = currentYear + 2; // up to 20 years in the future
    const years = Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index);
    const getMonthName = (monthNumber) => {
        const months = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];
        return months[monthNumber - 1];
    };


    const [filterMonth, setFilterMonth] = useState(month || 'null')
    const [filterYear, setFilterYear] = useState(year || "null");

    const [buffer, setBuffering] = useState(true); //buffering logic
    const employee = sessionStorage.getItem("employee_id")
    const [timeSheetData, setTimeSheetData] = useState([]);
    const role = sessionStorage.getItem("role");

    const getTimesheet = async () => {
        setBuffering(true); // Start Buffering
        let url;
        try {

            url = `${BASE_URL_PREBID}/project/modelcount/${filterMonth}/${filterYear}`;//ProjectPAndLAPIView

            const sub = await axios.get(url);

            setTimeSheetData(sub.data);
        } catch (err) {
            handleErrorToast(err); // Toast Logic
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    useEffect(() => {
        if (employee != "") {
            console.log("useffect running ", employee)
            getTimesheet();
        }

    }, [filterMonth, filterYear, employee]);
    const months = [
        { text: "January", value: 1 },
        { text: "February", value: 2 },
        { text: "March", value: 3 },
        { text: "April", value: 4 },
        { text: "May", value: 5 },
        { text: "June", value: 6 },
        { text: "July", value: 7 },
        { text: "August", value: 8 },
        { text: "September", value: 9 },
        { text: "October", value: 10 },
        { text: "November", value: 11 },
        { text: "December", value: 12 },
    ];



    return (
        <>
            <Dashboardnavbarcopy name="Data filled Progress" url="Data filled Progress" />



            <div className="content-tabs">

                <div className="attendance-subcont">

                    <div className="field-cont">

                        <div title='Month Filter' className="field-cont-div">
                            <CircularGrid />


                            <select
                                className="attendance-input-field width-10vw   date-field"
                                type="text"
                                value={filterMonth}
                                onChange={(e) => setFilterMonth(e.target.value)}
                            >
                                <option value="null">Select Month</option>
                                <option value="all">All Month</option>
                                <option value="1">January</option>
                                <option value="2">February</option>
                                <option value="3">March</option>
                                <option value="4">April</option>
                                <option value="5">May</option>
                                <option value="6">June</option>
                                <option value="7">July</option>
                                <option value="8">August</option>
                                <option value="9">September</option>
                                <option value="10">October</option>
                                <option value="11">November</option>
                                <option value="12">December</option>
                            </select>

                            <hr className="field-cont-hr" />



                        </div>

                        <div title='Year Filter' className="field-cont-div">
                            <CircularGrid />


                            <select
                                className="attendance-input-field width-10vw date-field"
                                value={filterYear}
                                onChange={(e) => setFilterYear(e.target.value)}
                            >
                                <option value="">Select Year</option>
                                <option value="all">All Years</option>
                                {years
                                    .slice() // Create a shallow copy to prevent modifying original array
                                    .reverse()
                                    .map((year) => (
                                        <option key={year} value={year}>{year}</option>
                                    ))}
                            </select>


                        </div>


                    </div>

                </div>


                <div className="table-css-white-background">
                    <div className="table-heading-flex">
                        {/* <div className="repo-heading font-weight500 font-size-heading">
                            Profit & Loss Sheet Table
                        </div> */}

                    </div>
                    {/* <SectorsDetailForm /> */}
                    <div className="table-box height-73vh">
                        <table className="table-css">
                            <thead className="table-heading">
                                <tr className="custom-table-head-tr">
                                    <th className="table-heading">Sr. No.</th>
                                    <th className="table-heading">Date</th>
                                    <th className="table-heading">Sub Company</th>
                                    <th className="table-heading text-center">Client Name</th>
                                    <th className="table-heading">Client</th>
                                    <th className="table-heading text-center">Project</th>
                                    <th className="table-heading">Project Details Client Wise</th>
                                    <th className="table-heading text-center">Work Stage</th>
                                    <th className="table-heading">Invoice</th>
                                    <th className="table-heading text-center">Payment Receipt</th>
                                    <th className="table-heading text-center">Document</th>
                                    <th className="table-heading text-center">Ticket Booking</th>
                                    <th className="table-heading">Miscellaneous</th>
                                    <th className="table-heading text-center">Timesheet</th>
                                    <th className="table-heading text-center">Remarks</th>
                                </tr>
                            </thead>

                            {buffer ? (
                                <Loader />
                            ) : (
                                <tbody>
                                    {timeSheetData
                                        ?.sort((a, b) => new Date(b.date) - new Date(a.date))
                                        .map((project, index) => (
                                            <React.Fragment key={index}>
                                                <tr className="tr-border-bottom">
                                                    <td colSpan="15"></td>
                                                </tr>
                                                <tr className="custom-table-head-td">
                                                    <td className="table-body">{index + 1}</td>
                                                    <td className="table-body">{formattedDateLong(project.date)}</td>
                                                    <td className="table-body text-center">
                                                        <span className={project.PrebidSubCompany?.added_data > 0 ? "success-message" : "blur-message"}>
                                                            {project.PrebidSubCompany?.added_data > 0 ? `+${project.PrebidSubCompany?.added_data}` : "+0"}
                                                        </span>
                                                        {" "}
                                                        <span className={project.PrebidSubCompany?.deleted_data > 0 ? "error-message" : "blur-message"}>
                                                            {project.PrebidSubCompany?.deleted_data > 0 ? `-${project.PrebidSubCompany?.deleted_data}` : "-0"}
                                                        </span>
                                                    </td>
                                                    <td className="table-body text-center">
                                                        <span className={project.ClientName?.added_data > 0 ? "success-message" : "blur-message"}>
                                                            {project.ClientName?.added_data > 0 ? `+${project.ClientName?.added_data}` : "+0"}
                                                        </span>
                                                        {" "}
                                                        <span className={project.ClientName?.deleted_data > 0 ? "error-message" : "blur-message"}>
                                                            {project.ClientName?.deleted_data > 0 ? `-${project.ClientName?.deleted_data}` : "-0"}
                                                        </span>
                                                    </td>
                                                    <td className="table-body text-center">
                                                        <span className={project.Client?.added_data > 0 ? "success-message" : "blur-message"}>
                                                            {project.Client?.added_data > 0 ? `+${project.Client?.added_data}` : "+0"}
                                                        </span>
                                                        {" "}
                                                        <span className={project.Client?.deleted_data > 0 ? "error-message" : "blur-message"}>
                                                            {project.Client?.deleted_data > 0 ? `-${project.Client?.deleted_data}` : "-0"}
                                                        </span>
                                                    </td>
                                                    <td className="table-body text-center">
                                                        <span className={project.Project?.added_data > 0 ? "success-message" : "blur-message"}>
                                                            {project.Project?.added_data > 0 ? `+${project.Project?.added_data}` : "+0"}
                                                        </span>
                                                        {" "}
                                                        <span className={project.Project?.deleted_data > 0 ? "error-message" : "blur-message"}>
                                                            {project.Project?.deleted_data > 0 ? `-${project.Project?.deleted_data}` : "-0"}
                                                        </span>
                                                    </td>
                                                    <td className="table-body text-center">
                                                        <span className={project.ProjectDetailsClientWise?.added_data > 0 ? "success-message" : "blur-message"}>
                                                            {project.ProjectDetailsClientWise?.added_data > 0 ? `+${project.ProjectDetailsClientWise?.added_data}` : "+0"}
                                                        </span>
                                                        {" "}
                                                        <span className={project.ProjectDetailsClientWise?.deleted_data > 0 ? "error-message" : "blur-message"}>
                                                            {project.ProjectDetailsClientWise?.deleted_data > 0 ? `-${project.ProjectDetailsClientWise?.deleted_data}` : "-0"}
                                                        </span>
                                                    </td>
                                                    <td className="table-body text-center">
                                                        <span className={project.WorkStage?.added_data > 0 ? "success-message" : "blur-message"}>
                                                            {project.WorkStage?.added_data > 0 ? `+${project.WorkStage?.added_data}` : "+0"}
                                                        </span>
                                                        {" "}
                                                        <span className={project.WorkStage?.deleted_data > 0 ? "error-message" : "blur-message"}>
                                                            {project.WorkStage?.deleted_data > 0 ? `-${project.WorkStage?.deleted_data}` : "-0"}
                                                        </span>
                                                    </td>
                                                    <td className="table-body text-center">
                                                        <span className={project.Invoice?.added_data > 0 ? "success-message" : "blur-message"}>
                                                            {project.Invoice?.added_data > 0 ? `+${project.Invoice?.added_data}` : "+0"}
                                                        </span>
                                                        {" "}
                                                        <span className={project.Invoice?.deleted_data > 0 ? "error-message" : "blur-message"}>
                                                            {project.Invoice?.deleted_data > 0 ? `-${project.Invoice?.deleted_data}` : "-0"}
                                                        </span>
                                                    </td>
                                                    <td className="table-body text-center">
                                                        <span className={project.PaymentReceipt?.added_data > 0 ? "success-message" : "blur-message"}>
                                                            {project.PaymentReceipt?.added_data > 0 ? `+${project.PaymentReceipt?.added_data}` : "+0"}
                                                        </span>
                                                        {" "}
                                                        <span className={project.PaymentReceipt?.deleted_data > 0 ? "error-message" : "blur-message"}>
                                                            {project.PaymentReceipt?.deleted_data > 0 ? `-${project.PaymentReceipt?.deleted_data}` : "-0"}
                                                        </span>
                                                    </td>
                                                    <td className="table-body text-center">
                                                        <span className={project.Document?.added_data > 0 ? "success-message" : "blur-message"}>
                                                            {project.Document?.added_data > 0 ? `+${project.Document?.added_data}` : "+0"}
                                                        </span>
                                                        {" "}
                                                        <span className={project.Document?.deleted_data > 0 ? "error-message" : "blur-message"}>
                                                            {project.Document?.deleted_data > 0 ? `-${project.Document?.deleted_data}` : "-0"}
                                                        </span>
                                                    </td>
                                                    <td className="table-body text-center">
                                                        <span className={project.TicketBooking?.added_data > 0 ? "success-message" : "blur-message"}>
                                                            {project.TicketBooking?.added_data > 0 ? `+${project.TicketBooking?.added_data}` : "+0"}
                                                        </span>
                                                        {" "}
                                                        <span className={project.TicketBooking?.deleted_data > 0 ? "error-message" : "blur-message"}>
                                                            {project.TicketBooking?.deleted_data > 0 ? `-${project.TicketBooking?.deleted_data}` : "-0"}
                                                        </span>
                                                    </td>
                                                    <td className="table-body text-center">
                                                        <span className={project.Miscellaneous?.added_data > 0 ? "success-message" : "blur-message"}>
                                                            {project.Miscellaneous?.added_data > 0 ? `+${project.Miscellaneous?.added_data}` : "+0"}
                                                        </span>
                                                        {" "}
                                                        <span className={project.Miscellaneous?.deleted_data > 0 ? "error-message" : "blur-message"}>
                                                            {project.Miscellaneous?.deleted_data > 0 ? `-${project.Miscellaneous?.deleted_data}` : "-0"}
                                                        </span>
                                                    </td>
                                                    <td className="table-body text-center">
                                                        <span className={project.Timesheet?.added_data > 0 ? "success-message" : "blur-message"}>
                                                            {project.Timesheet?.added_data > 0 ? `+${project.Timesheet?.added_data}` : "+0"}
                                                        </span>
                                                        {" "}
                                                        <span className={project.Timesheet?.deleted_data > 0 ? "error-message" : "blur-message"}>
                                                            {project.Timesheet?.deleted_data > 0 ? `-${project.Timesheet?.deleted_data}` : "-0"}
                                                        </span>
                                                    </td>
                                                    <td className="table-body text-center">
                                                        <span className={project.Remark?.added_data > 0 ? "success-message" : "blur-message"}>
                                                            {project.Remark?.added_data > 0 ? `+${project.Remark?.added_data}` : "+0"}
                                                        </span>
                                                        {" "}
                                                        <span className={project.Remark?.deleted_data > 0 ? "error-message" : "blur-message"}>
                                                            {project.Remark?.deleted_data > 0 ? `-${project.Remark?.deleted_data}` : "-0"}
                                                        </span>
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        ))}
                                </tbody>
                            )}
                        </table>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </div>
            </div>
        </>
    );
};



export { Progressprebid };
